import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-connect-text-message-platform',
  templateUrl: './connect-text-message-platform.component.html',
  styleUrls: ['./connect-text-message-platform.component.scss']
})
export class ConnectTextMessagePlatformComponent {
  @Input() partner;
  @Input() selectTextMessagePlatform;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  onConnected() {
    this.activeModal.close('Connected');
  }
}
